module.exports = __webpack_public_path__ + "img/figure-15.07d5aaa6.png";